import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type {
  SettlementStoreParams,
  SettlementStoreResponse,
} from '~/features/dashboard/types/settlement.type';

/**
 * 매장별 정산 현황 조회 (MANAGER 이상)
 * @endpoint GET /admin/dashboard/settlement/stores/{storeId}
 */
export function getSettlementStoreApi(params: SettlementStoreParams) {
  return axiosInstance.get<ApiResponse<SettlementStoreResponse>>(
    `/admin/dashboard/settlement/stores/${params.storeId}`,
    { params: { startDate: params.startDate, endDate: params.endDate } },
  );
}
